import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { useAccountReadiness } from '../lib/readiness';
import { QueryBoundary } from './QueryBoundary';
import { ReadinessLadder } from './ReadinessLadder';
import { Skeleton } from './Skeleton';

// The ACCOUNT scope of the readiness ladder — the answer the wizard never gave.
//
// THE DEFECT THIS CLOSES. The funnel's terminal card said "You are all set" on
// the strength of `Account.onboardingState === 'active'`, which records WHICH
// WIZARD STEPS THE USER WALKED and nothing else. Whether the account can
// actually run work is a different fact entirely — a live read over keys,
// installations, repos and boxes — and the two disagree in the ordinary case,
// not the exotic one: the funnel has no step that enrols a machine, so every
// account that clicks through it reaches `active` with `scout_box` blocked.
// The user's next act is a scout call, and the first thing that told them was
// a `no_scout_capacity` refusal arriving through their agent.
//
// It owns its own read rather than taking a prop, because both mount points
// (the terminal card, Home) want the same query and TanStack dedupes it by key.
export function AccountReadiness(props: { readonly token: string | null }): JSX.Element {
  const readiness = useAccountReadiness(props.token);
  return (
    <QueryBoundary query={readiness} loading={<Skeleton height="12rem" />}>
      {(ladder) => (
        <ReadinessLadder
          ladder={ladder}
          title={t('readiness.account_title')}
          desc={t('readiness.account_desc')}
          source={t('readiness.account_source')}
        />
      )}
    </QueryBoundary>
  );
}
